import Popover from 'bootstrap/js/dist/popover';

export function initPopover() {
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
  if(popoverTriggerList.length > 0){
    [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl))
              }
}   